'use client';

import Link from 'next/link';

export default function RGPDPage() {
  const currentYear = new Date()?.getFullYear();

  return (
    <div style={{ backgroundColor: '#F8F9FA', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <header style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link href="/landing-page" aria-label="GestPub — Gestão Pública e Consultoria Autárquica — Página inicial" className="inline-block focus-visible:outline-none">
            <img
              src="/assets/images/6-1773621431219.png"
              alt="GestPub — Gestão Pública e Consultoria Autárquica"
              style={{ height: 38, width: 'auto', display: 'block', flexShrink: 0, mixBlendMode: 'multiply' }}
            />
          </Link>
          <Link
            href="/landing-page"
            style={{ fontSize: '0.82rem', color: '#6B7280', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#272727')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}
          >
            Voltar à página inicial
          </Link>
        </div>
      </header>
      {/* Teal accent line */}
      <div className="h-1" style={{ backgroundColor: '#009688' }} />
      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-14">
        {/* Page title */}
        <div className="mb-10">
          <p style={{ fontSize: '0.75rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#009688', fontWeight: 600, marginBottom: '0.75rem' }}>
            GestPub, Serviço GP Otimiza
          </p>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#272727', lineHeight: 1.25, marginBottom: '0.5rem' }}>
            RGPD
          </h1>
          <p style={{ fontSize: '1rem', color: '#6B7280', marginBottom: '0.5rem' }}>
            Regulamento Geral sobre a Proteção de Dados
          </p>
          <p style={{ fontSize: '0.85rem', color: '#6B7280' }}>
            Última atualização: março de {currentYear}
          </p>
        </div>

        <div style={{ backgroundColor: '#FFFFFF', borderRadius: 10, border: '1px solid rgba(0,0,0,0.08)', padding: '2.5rem' }}>
          <div className="space-y-8" style={{ color: '#374151', lineHeight: 1.75, fontSize: '0.92rem' }}>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>1. Enquadramento Legal</h2>
              <p>
                O Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho, de 27 de abril de 2016, relativo à proteção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados (RGPD), é aplicável à atividade da <strong>GestPub – Gestão Pública e Consultoria Autárquica, Lda.</strong>, incluindo no âmbito da plataforma de diagnóstico GP Otimiza.
              </p>
              <p className="mt-3">
                A GestPub assume o compromisso de tratar os dados pessoais dos utilizadores da plataforma em conformidade com o RGPD e com a legislação nacional complementar, nomeadamente a Lei n.º 58/2019, de 8 de agosto.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>2. Responsável pelo Tratamento</h2>
              <p>
                Nos termos do artigo 4.º, n.º 7, do RGPD, o responsável pelo tratamento dos dados pessoais recolhidos através da plataforma GP Otimiza é:
              </p>
              <div className="mt-3 p-4 rounded-lg" style={{ backgroundColor: '#F8F9FA', border: '1px solid rgba(0,0,0,0.06)' }}>
                <p><strong>GestPub – Gestão Pública e Consultoria Autárquica, Lda.</strong></p>
                <p>Avenida da República, Ed. República, 1.º Piso, Escritório E, Alcoitão</p>
                <p>2645-143 Estoril, Portugal</p>
                <p>Correio eletrónico: <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a></p>
                <p>Telefone: (+351) 214 846 546</p>
              </div>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>3. Categorias de Dados Tratados</h2>
              <p>No âmbito da plataforma GP Otimiza, a GestPub trata as seguintes categorias de dados pessoais:</p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li><strong>Dados de identificação:</strong> nome completo, cargo ou função, município de representação;</li>
                <li><strong>Dados de contacto:</strong> endereço de correio eletrónico institucional, número de telefone (facultativo);</li>
                <li><strong>Dados de diagnóstico:</strong> respostas ao questionário de avaliação da capacidade organizacional municipal.</li>
              </ul>
              <p className="mt-3">
                Não são tratados dados pessoais sensíveis, conforme definidos no artigo 9.º do RGPD.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>4. Finalidades e Bases Legais do Tratamento</h2>
              <p>Os dados pessoais são tratados para as seguintes finalidades, com as respetivas bases legais:</p>
              <div className="mt-3 space-y-3">
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0' }}>
                  <p><strong>Geração do relatório de diagnóstico</strong></p>
                  <p style={{ fontSize: '0.85rem', color: '#6B7280', marginTop: '0.25rem' }}>Base legal: interesse legítimo do responsável pelo tratamento (artigo 6.º, n.º 1, alínea f) do RGPD)</p>
                </div>
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0' }}>
                  <p><strong>Contacto para apresentação de propostas de intervenção</strong></p>
                  <p style={{ fontSize: '0.85rem', color: '#6B7280', marginTop: '0.25rem' }}>Base legal: consentimento do titular (artigo 6.º, n.º 1, alínea a) do RGPD), prestado de forma livre, específica, informada e inequívoca</p>
                </div>
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0' }}>
                  <p><strong>Envio de informação institucional sobre o GP Otimiza e a GestPub</strong></p>
                  <p style={{ fontSize: '0.85rem', color: '#6B7280', marginTop: '0.25rem' }}>Base legal: consentimento do titular (artigo 6.º, n.º 1, alínea a) do RGPD)</p>
                </div>
              </div>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>5. Direitos dos Titulares dos Dados</h2>
              <p>Nos termos do RGPD, os titulares dos dados pessoais tratados pela GestPub no âmbito da plataforma GP Otimiza têm os seguintes direitos:</p>
              <div className="mt-3 space-y-2">
                {[
                  { right: 'Direito de acesso', desc: 'Obter confirmação sobre se os seus dados são tratados e aceder aos mesmos (artigo 15.º do RGPD).' },
                  { right: 'Direito de retificação', desc: 'Solicitar a correção de dados inexatos ou incompletos (artigo 16.º do RGPD).' },
                  { right: 'Direito ao apagamento', desc: 'Solicitar a eliminação dos seus dados, nos casos previstos na lei (artigo 17.º do RGPD).' },
                  { right: 'Direito à limitação do tratamento', desc: 'Solicitar a suspensão do tratamento em determinadas circunstâncias (artigo 18.º do RGPD).' },
                  { right: 'Direito à portabilidade', desc: 'Receber os seus dados num formato estruturado e de uso corrente, quando aplicável (artigo 20.º do RGPD).' },
                  { right: 'Direito de oposição', desc: 'Opor-se ao tratamento baseado em interesse legítimo (artigo 21.º do RGPD).' },
                  { right: 'Direito de retirada do consentimento', desc: 'Retirar o consentimento a qualquer momento, sem prejuízo da licitude do tratamento anterior (artigo 7.º, n.º 3, do RGPD).' },
                ]?.map((item) => (
                  <div key={item?.right} className="flex gap-3">
                    <div className="flex-shrink-0 mt-1" style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#009688', marginTop: '0.45rem' }} />
                    <p><strong>{item?.right}:</strong> {item?.desc}</p>
                  </div>
                ))}
              </div>
              <p className="mt-4">
                Para exercer qualquer um destes direitos, o titular deve enviar um pedido escrito para <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a>, identificando-se devidamente. A GestPub responderá no prazo máximo de 30 dias a contar da receção do pedido.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>6. Prazo de Conservação</h2>
              <p>
                Os dados pessoais são conservados pelo período estritamente necessário à prossecução das finalidades para as quais foram recolhidos, não excedendo, em regra, 24 meses a contar da data de submissão do diagnóstico. Findo este prazo, os dados são eliminados ou anonimizados, salvo obrigação legal de conservação por prazo superior.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>7. Transferências Internacionais de Dados</h2>
              <p>
                A GestPub não realiza transferências de dados pessoais para países terceiros fora do Espaço Económico Europeu. Todos os dados são tratados e armazenados em servidores localizados no território da União Europeia, em conformidade com o RGPD.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>8. Medidas de Segurança</h2>
              <p>
                A GestPub implementa medidas técnicas e organizativas adequadas para garantir um nível de segurança apropriado ao risco associado ao tratamento dos dados pessoais, nos termos do artigo 32.º do RGPD. Estas medidas incluem, entre outras, a encriptação dos dados em trânsito, o controlo de acessos e a formação regular dos colaboradores em matéria de proteção de dados.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>9. Reclamações junto da Autoridade de Controlo</h2>
              <p>
                Sem prejuízo de qualquer outro recurso administrativo ou judicial, o titular dos dados tem o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD), autoridade de controlo competente em Portugal, caso considere que o tratamento dos seus dados pessoais viola o RGPD.
              </p>
              <div className="mt-3 p-4 rounded-lg" style={{ backgroundColor: '#F8F9FA', border: '1px solid rgba(0,0,0,0.06)' }}>
                <p><strong>Comissão Nacional de Proteção de Dados (CNPD)</strong></p>
                <p>Rua de São Bento, n.º 148, 3.º, 1200-821 Lisboa</p>
                <p>Correio eletrónico: <a href="mailto:geral@cnpd.pt" style={{ color: '#009688' }}>geral@cnpd.pt</a></p>
                <p>Sítio web: <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer" style={{ color: '#009688' }}>www.cnpd.pt</a></p>
              </div>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>10. Contacto do Responsável pelo Tratamento</h2>
              <p>
                Para qualquer questão relacionada com o tratamento dos seus dados pessoais ao abrigo do RGPD, pode contactar a GestPub através dos seguintes meios:
              </p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Correio eletrónico: <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a></li>
                <li>Telefone: (+351) 214 846 546</li>
                <li>Morada: Avenida da República, Ed. República, 1.º Piso, Escritório E, Alcoitão, 2645-143 Estoril</li>
              </ul>
            </section>

          </div>
        </div>
      </main>
      {/* Footer */}
      <footer style={{ backgroundColor: '#272727' }}>
        <div className="h-1" style={{ backgroundColor: '#009688' }} />
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
            &copy; {currentYear} GestPub – Gestão Pública e Consultoria Autárquica. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            {[
              { label: 'Política de Privacidade', href: '/politica-de-privacidade' },
              { label: 'Termos de Utilização', href: '/termos-de-utilizacao' },
              { label: 'RGPD', href: '/rgpd' },
            ]?.map((link) => (
              <Link
                key={link?.label}
                href={link?.href}
                className="transition-colors duration-200"
                style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: link?.href === '/rgpd' ? '#FFFFFF' : 'rgba(255,255,255,0.35)', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                onMouseLeave={(e) => (e.currentTarget.style.color = link?.href === '/rgpd' ? '#FFFFFF' : 'rgba(255,255,255,0.35)')}
              >
                {link?.label}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
